import { Award, BadgeCheck, TrendingUp, Headset } from "lucide-react";
import { SectionHead, Stagger, StaggerItem } from "@/components/Reveal";

const ITEMS = [
  {
    icon: Award,
    title: "Veteran Microsoft Expertise",
    text: "Led by Microsoft veterans with 15+ years of enterprise cloud experience — deep understanding of Azure architecture and best practices.",
  },
  {
    icon: BadgeCheck,
    title: "AWS Certified Excellence",
    text: "A team of AWS-certified architects and engineers with a proven track record in multi-cloud deployments.",
  },
  {
    icon: TrendingUp,
    title: "Startup-to-Enterprise Scalability",
    text: "Solutions that grow with your business — from startup MVP to enterprise scale, with flexible, cost-optimized infrastructure.",
  },
  {
    icon: Headset,
    title: "24/7 Support & Optimization",
    text: "Continuous monitoring, cost optimization, and proactive support. Peace of mind with fully managed services.",
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 sm:py-32 bg-nexlight">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHead
          chapter="01"
          overline="Why NexOrbit"
          title="Why Choose NexOrbit Solutions?"
          sub="Enterprise expertise meets startup agility. We bring veteran-led depth and growth-oriented thinking to every engagement."
          testId="why-us-heading"
        />
        <Stagger className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {ITEMS.map(({ icon: Icon, title, text }, i) => (
            <StaggerItem key={title}>
              <div
                data-testid={`why-us-card-${i + 1}`}
                className="group h-full rounded-2xl border border-nexblue/10 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:border-nexcyan/50"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-nexblue text-nexcyan transition-colors duration-300 group-hover:bg-nexcyan group-hover:text-white">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-display text-xl sm:text-2xl font-semibold text-nexblue">{title}</h3>
                <p className="mt-3 text-base leading-relaxed text-nexink/70">{text}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
